var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5ZM31.8183 17.5001C31.8183 25.4078 25.4078 31.8183 17.5001 31.8183C9.59236 31.8183 3.18189 25.4078 3.18189 17.5001C3.18189 9.59236 9.59236 3.18189 17.5001 3.18189C25.4078 3.18189 31.8183 9.59236 31.8183 17.5001ZM17.5516 28.6364C12.2101 28.6364 9.23805 25.823 9.23805 20.6819V19.0909H25.6393L25.6833 20.6366C25.8302 25.7958 22.9102 28.6364 17.5516 28.6364ZM22.4112 22.2726C22.0374 24.4927 20.5361 25.4545 17.5502 25.4545C14.566 25.4545 13.0157 24.4844 12.5622 22.2726H22.4112ZM20.6819 11.1364H25.4546V14.3182H20.6819V11.1364ZM14.3184 11.1364H9.54567V14.3182H14.3184V11.1364Z",
    fill: "#E74C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.0d10470748fb8bab15426cbfe187fe6b.svg";
export { ForwardRef as ReactComponent };